import { values, isEmpty, isNil, pick } from 'ramda';
import businessInfoTemplate from './businessInfo.tpl.html';
import { getBusinessInformationById, getLoading } from '../../../../reducers/businessInformations';
import { getBITemplateById } from '../../../../reducers/businessInformationTemplates';

export class BusinessInfo {
  constructor($scope, $ngRedux, actionsFactory, $translate, $location, $anchorScroll) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      $location,
      $anchorScroll,
    });
    const unsubscribe = $ngRedux.connect(BusinessInfo.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);

    this.scoreLegend = [
      {
        min: 0,
        max: 0,
        value: 'C',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_CRITICAL')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_CRITICAL')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_CRITICAL')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_CRITICAL')}`,
      },
      {
        min: 1,
        max: 25,
        value: 'CC',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_WEAK')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_WEAK')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_WEAK')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_WEAK')}`,
      },
      {
        min: 26,
        max: 40,
        value: 'CCC',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_WEAK')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_WEAK')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_WEAK')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_WEAK')}`,
      },
      {
        min: 41,
        max: 50,
        value: 'B',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_FAIR')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_FAIR')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR')}`,
      },
      {
        min: 51,
        max: 60,
        value: 'BB',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_FAIR')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_FAIR')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR')}`,
      },
      {
        min: 61,
        max: 70,
        value: 'BBB',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_FAIR')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_FAIR')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR')}`,
      },
      {
        min: 71,
        max: 80,
        value: 'A',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_GOOD')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_GOOD')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_GOOD')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_GOOD')}`,
      },
      {
        min: 81,
        max: 90,
        value: 'AA',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_GOOD')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_GOOD')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_GOOD')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_GOOD')}`,
      },
      {
        min: 91,
        max: 100,
        value: 'AAA',
        label: `${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_EXCELLENT')}`,
        descriptionBase: `${this.$translate.instant('SCORE_LEGEND_BASE_DESCRIPTION_EXCELLENT')}`,
        descriptionTop: `${this.$translate.instant('SCORE_LEGEND_TOP_DESCRIPTION_EXCELLENT')}`,
        descriptionPremium: `${this.$translate.instant('SCORE_LEGEND_PREMIUM_DESCRIPTION_EXCELLENT')}`,
      },
    ];

    this.scoreLegendContent = undefined;

    this.getIntValue = BusinessInfo.getIntValue;
    this.getReputationScore = BusinessInfo.getReputationScore;
  }

  static mapStateToThis(state) {
    const businessInformation = getBusinessInformationById(
      state, state.router.currentParams.businessInfoId);
    const template = getBITemplateById(state, businessInformation && businessInformation.template);

    return {
      auth: state.authentication,
      router: state.router,
      businessInfo: businessInformation,
      template,
      loading: getLoading(state),
      company: state.companies.byId[state.router.currentParams.id],
    };
  }

  $onInit() {
    this.reqBusinessInfoOrder(this.router.currentParams.businessInfoId);
  }

  scrollTo(hash) {
    this.$location.hash(hash).replace();
    this.$anchorScroll();
  }

  /* eslint-disable */
  isValueEmpty(value) {
    return isNil(value) || isEmpty(value) || value === 'NaN';
  }

  isSetEmpty(rows) {
    return this.getFilteredSet(rows).length === 0;
  }

  getFilteredSet(rows) {
    const isColumnEmpty = element =>
    !element || isNil(element.value) || isEmpty(element.value) || element.value === 'NaN';

    return (rows || [])
      .filter(row =>
        !values(row)
          .map(column => isColumnEmpty(column))
          .reduce((columnEmpty, rowEmpty) => rowEmpty && columnEmpty));
  }
  /* eslint-enable */

  saveEditableField(section, text) {
    this.businessInfo.notes[section] = {};
    this.businessInfo.notes[section] = {
      sectionId: section,
      value: text,
    };
    const notes = values(this.businessInfo.notes)
      .map(obj => ({
        section_id: obj.sectionId,
        value: obj.value,
      }));
    this.updateBusinessInfoNotes(
      this.router.currentParams.businessInfoId,
      notes,
      this.businessInfo.score,
      this.businessInfo.trustStatement,
      this.router.currentParams.id,
      this.businessInfo.companyContacts);
  }

  setBusinessInfoToDraft() {
    this.setBusinessInfoToDraftStart(this.router.currentParams.businessInfoId);
  }

  partialSave() {
    const notes = values(this.businessInfo.notes)
      .map(obj => ({
        section_id: obj.sectionId,
        value: obj.value,
      }));
    this.updateBusinessInfoNotes(
      this.router.currentParams.businessInfoId,
      notes,
      this.businessInfo.score,
      this.businessInfo.trustStatement,
      this.router.currentParams.id,
      this.businessInfo.companyContacts);
  }

  getLegendForScore() {
    if (!this.scoreLegendContent) {
      const rows = this.scoreLegend
        .map(legend => Object.assign({}, pick([
          'min',
          'max',
          'value',
        ], legend), {
          description: legend.label,
        }))
        .map(legend => `<tr><td><strong>${legend.value} - ${legend.description}<strong></td><td>${legend.min}</td><td>${legend.max}</td></tr>`)
        .join('');
      const legendTitle = this.$translate.instant('SCORE_LEGEND_TITLE');
      this.scoreLegendContent = `<h1 class="score-legend-title">${legendTitle}</h1><table class="score-legend-table">${rows}</table>`;
    }

    return this.scoreLegendContent;
  }

  static getIntValue(value) {
    if (value === null || value === undefined) {
      return '-';
    }

    return (value > 0) ? 'C' : 'A';
  }

  static getReputationScore(order, type) {
    let scoreValue = '';

    if (typeof order !== 'undefined') {
      scoreValue = Math.round(order.avgScore);

      if (type === 'label') {
        return this.scoreLegend
          .find(el => scoreValue >= el.min && scoreValue <= el.max).label;
      } else if (type === 'value') {
        return this.scoreLegend
          .find(el => scoreValue >= el.min && scoreValue <= el.max).value;
      }
    }

    return scoreValue;
  }

  getScoreValue(score) {
    if (score === null || score === undefined || score < 0 || score > 100) {
      return '-';
    }
    return this.scoreLegend
      .find(el => Math.round(score) >= el.min && Math.round(score) <= el.max).value;
  }

  getScoreLabel(score) {
    if (score === null || score === undefined || score < 0 || score > 100) {
      return '-';
    }
    return this.scoreLegend
      .find(el => Math.round(score) >= el.min && Math.round(score) <= el.max).label;
  }

  getDocScoreDescription(score) {
    if (score === null || score === undefined || score < 0 || score > 100) {
      return '-';
    }
    return this.scoreLegend
      .find(el => Math.round(score) >= el.min && Math.round(score) <= el.max).descriptionBase;
  }

  getScoreLegend(score) {
    const legendTitle = this.$translate.instant('SCORE_LEGEND_TITLE');

    const tiles = this.scoreLegend
      .map((el) => {
        const active = Math.round(score) >= el.min && Math.round(score) <= el.max ? 'active' : '';
        return `<div class="tile ${active}"><span class="tile__score">${el.value}</span><span class="tct-score-brick tile__brick tct-score-brick--${el.value}"></span></div>`;
      })
      .join('');

    const legend = `<h2>${legendTitle}</h2><div class="tiles">${tiles}</div>`;
    return legend;
  }

  saveAndAccept() {
    const notes = values(this.businessInfo.notes)
      .map(obj => ({
        section_id: obj.sectionId,
        value: obj.value,
      }));
    this.setBusinessInfoCompleted(
      this.router.currentParams.businessInfoId,
      notes,
      this.businessInfo.score,
      this.businessInfo.trustStatement,
      this.router.currentParams.id,
      this.businessInfo.companyContacts);
  }

  isReadOnly() {
    const check = this.businessInfo && this.businessInfo.status;

    if (check) {
      return this.businessInfo.status === 'completed';
    }

    return false;
  }
}

BusinessInfo.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  '$location',
  '$anchorScroll',
];

export const businessInfo = {
  template: businessInfoTemplate,
  controller: BusinessInfo,
};
